import { OtpValidationData } from "Services/api/otp/interfaces";

export function getFullPhoneFormat(tel: OtpValidationData["to"]): `+1${string}` {
  return `+1${tel}`;
}
